var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 124,
    viewBox: "0 0 334 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.2 109.5H194V111.9H195.2V123.8H196.4V111.9H200V109.5H196.4V103H195.2V109.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.7 109.5H181.5V123.8H182.7V109.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.7 103H181.5V107.2H182.7V103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.3 95.6C158.699 95.6 180.1 74.1992 180.1 47.8C180.1 21.4008 158.699 0 132.3 0C105.901 0 84.5 21.4008 84.5 47.8C84.5 74.1992 105.901 95.6 132.3 95.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9 20.3C16.1 20.3 0 36.4001 0 56.1001V105.7H17.9V87.1001C23.4 90.2001 29.5 91.9001 35.8 91.9001C55.6 91.9001 71.7 75.8001 71.7 56.1001C71.7 36.3001 55.7 20.3 35.9 20.3ZM35.9 74.0001C26 74.0001 18 66.0001 18 56.1001C18 46.2001 26 38.2001 35.9 38.2001C45.8 38.2001 53.8 46.2001 53.8 56.1001C53.8 66.0001 45.8 74.0001 35.9 74.0001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.5 103H161.3V123.8H162.5V117.2L164.7 115.3L170 123.8H171.4L165.6 114.5L171.4 109.5H167.7L162.5 114V103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.1 111.9H147.6V114.3H148.8V109.5H138.7V123.8H141.1V111.9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.8 109.5H116.1V111.9H123.8C124.5 111.9 125 112.4 125 113.1V115.5H120.2C117.9 115.5 116 117.4 116 119.7C116 122 117.9 123.9 120.2 123.9H126.1V111.9C126.2 110.6 125.1 109.5 123.8 109.5ZM125 121.4H120.2C119.2 121.4 118.4 120.6 118.4 119.6C118.4 118.6 119.2 117.8 120.2 117.8H125V121.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.8 109.5H257.7V111.9H258.8V123.8H260V111.9H263.6V109.5H260V103H258.8V109.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.1 111.9H307.6V114.3H308.8V109.5H298.7V123.8H301.1V111.9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.9 19.8C248.8 19.8 242.7 21.4001 237.4 24.4001V20.3H219.5V92.0001H237V56.2001C237 46.3001 245 38.3 254.9 38.3C264.8 38.3 272.8 46.3001 272.8 56.2001V92.0001H290.7V55.7001C290.7 35.9001 274.6 19.8 254.9 19.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.2 38.1999V20.2999H315.3V2.3999H297.4V56.1999C297.4 75.9999 313.5 91.9999 333.3 91.9999V74.0999C323.4 74.0999 315.4 66.0999 315.4 56.1999V38.2999H333.2V38.1999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.9 20.3H193V92H210.9V20.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.4 109.5C323.6 109.5 321.3 111.8 321.3 114.6V121.4C321.3 122.7 322.4 123.8 323.7 123.8H331.4V122.6H323.7C323 122.6 322.5 122.1 322.5 121.4V119H331.4V114.5C331.4 111.8 329.1 109.5 326.4 109.5ZM330.2 116.7H322.5V114.6C322.5 112.5 324.2 110.7 326.4 110.7C328.6 110.7 330.3 112.4 330.3 114.6V116.7H330.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 121.4H281.1C279.6 121.4 278.4 120.2 278.4 118.7V109.5H276V118.7C276 121.5 278.3 123.8 281.1 123.8H286.2V109.5H285V121.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.5 109.5C214.7 109.5 212.4 111.8 212.4 114.6V121.4C212.4 122.7 213.5 123.8 214.8 123.8H222.5V122.6H214.8C214.1 122.6 213.6 122.1 213.6 121.4V119H222.5V114.5C222.6 111.8 220.3 109.5 217.5 109.5ZM221.4 116.7H213.6V114.6C213.6 112.5 215.3 110.7 217.5 110.7C219.7 110.7 221.4 112.4 221.4 114.6V116.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.9 2.3999H193V11.7999H210.9V2.3999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.2 103H235V123.8H236.2V117.2L238.5 115.3L243.8 123.8H245.2L239.4 114.5L245.2 109.5H241.5L236.2 114V103Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 333.3,
    height: 123.9,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a3474833ad9b2df1659f7ece89b8ac6b.svg";
export { ForwardRef as ReactComponent };